import { connect, MapDispatchToProps } from 'react-redux';
import { uploadAvatar } from '../../../../../actions/avatar';
import { Props } from './AvatarEditPopup';

type DispatchProps = Pick<Props, 'uploadAvatar'>;
type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  uploadAvatar,
};

export default connect(null, mapDispatchToProps);
